import { useEffect, useCallback } from 'react';
import { COUNSELLOR_OVERLAY_CONFIG } from '../components/overlays/counsellorOverlayConfig';

function useAppRouting({ onRouteStateChange }) {
  const getStateFromUrl = useCallback(() => {
    const path = window.location.pathname;
    if (path === '/customclientbuilder') return { overlay: null, clientId: null, customBuilder: true };
    if (path === '/clientsmenu') return { overlay: 'client', clientId: null };
    if (path === '/counsellorsmenu') return { overlay: 'counsellor-freeform', clientId: null };
    if (path === '/automatedmiscmiti') return { overlay: 'automated-misc-miti', clientId: null };
    if (path === '/simplereflectionsmenu') return { overlay: 'simple-reflections', clientId: null };
    if (path === '/affirmationsmenu') return { overlay: 'affirmations', clientId: null };
    if (path === '/complexreflectionsmenu') return { overlay: 'complex-reflections', clientId: null };
    if (path === '/about') return { overlay: 'about', clientId: null };
    if (path === '/workingalliance') return { overlay: 'working-alliance', clientId: null };
    if (path === '/lectures') return { overlay: 'lectures', clientId: null };
    if (path === '/tutorial') return { overlay: 'tutorial', clientId: null };
    if (path === '/account') return { overlay: 'account', clientId: null };
    if (path === '/contact') return { overlay: 'contacts', clientId: null };
    if (path === '/customclient') return { overlay: null, clientId: -1 };
    if (path === '/betheclient') return { overlay: null, clientId: -2 };
    if (path === '/specificskills') return { overlay: null, clientId: -3 };
    if (path === '/specificstrategies') return { overlay: null, clientId: -4 };
    for (const [overlayId, config] of Object.entries(COUNSELLOR_OVERLAY_CONFIG)) {
      if (path === config.path) return { overlay: overlayId, clientId: null };
    }
    const clientMatch = path.match(/^\/client(\d+)$/);
    if (clientMatch) return { overlay: null, clientId: parseInt(clientMatch[1], 10) };
    return { overlay: null, clientId: null };
  }, []);

  const updateUrl = useCallback((overlay, clientId, replace = false, customBuilder = false) => {
    let path = '/';
    if (customBuilder) path = '/customclientbuilder';
    else if (overlay === 'client') path = '/clientsmenu';
    else if (overlay && COUNSELLOR_OVERLAY_CONFIG[overlay]) path = COUNSELLOR_OVERLAY_CONFIG[overlay].path;
    else if (overlay === 'counsellors') path = COUNSELLOR_OVERLAY_CONFIG['counsellor-freeform'].path;
    else if (overlay === 'automated-misc-miti') path = '/automatedmiscmiti';
    else if (overlay === 'simple-reflections') path = '/simplereflectionsmenu';
    else if (overlay === 'affirmations') path = '/affirmationsmenu';
    else if (overlay === 'complex-reflections') path = '/complexreflectionsmenu';
    else if (overlay === 'about') path = '/about';
    else if (overlay === 'working-alliance') path = '/workingalliance';
    else if (overlay === 'lectures') path = '/lectures';
    else if (overlay === 'tutorial') path = '/tutorial';
    else if (overlay === 'account') path = '/account';
    else if (overlay === 'contacts') path = '/contact';
    else if (clientId === -1) path = '/customclient';
    else if (clientId === -2) path = '/betheclient';
    else if (clientId === -3) path = '/specificskills';
    else if (clientId === -4) path = '/specificstrategies';
    else if (clientId !== null) path = `/client${clientId}`;

    const method = replace ? 'replaceState' : 'pushState';
    window.history[method]({ overlay, clientId, customBuilder }, '', path);
  }, []);

  useEffect(() => {
    const handlePopState = (event) => {
      onRouteStateChange(event.state || getStateFromUrl());
    };

    const initialState = getStateFromUrl();
    onRouteStateChange(initialState, { isInitialLoad: true, updateUrl });

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [getStateFromUrl, onRouteStateChange, updateUrl]);

  return {
    updateUrl,
  };
}

export default useAppRouting;
